<template>
  <AppCard class="card" :full-height="true">
    <template v-if="isCxApp()">
      <div>
        <div
          class="card-header t-flex t-flex-align-items-center t-flex-justify-content-space-between"
        >
          <h5 class="is-heading-5 title">
            {{ t("common.useCases") }}
          </h5>
          <scale-button variant="secondary" icon-only size="small">
            <scale-icon-device-device-ethernet accessibility-title="device-ethernet" size="14" />
          </scale-button>
        </div>
        <div class="card-content">
          <div class="card-content-section">
            <scale-tag
              v-if="useCases?.data?.length"
              v-for="useCase in useCases.data"
              :key="useCase._id"
              type="standard"
              class="t-mr-2 t-mb-2 t-inline-flex"
              >{{ useCase.name }}</scale-tag
            >
            <div v-else>{{ t("yourConnection.noUseCases") }}</div>
          </div>
        </div>
      </div>

      <hr />
    </template>
    <div>
      <div class="card-header t-flex t-mb-3">
        <scale-icon-alert-help accessibility-title="help" size="20" />
        <h6 class="is-size-6 t-ml-2">{{ t("yourConnection.help") }}</h6>
      </div>
      <div class="card-content">
        <div class="card-content-section">
          <div>
            <div>
              <scale-link target="_blank" :href="helpSection().documentation">
                {{ t("yourConnection.documentation") }}
                <scale-icon-navigation-external-link
                  size="16"
                  accessibility-title="open link in new tab"
                  slot="icon"
                />
              </scale-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppCard>
</template>
<script setup lang="ts">
import AppCard from "@/components/global/TCard/TCard.vue"
import { useI18n } from "vue-i18n"
import { useLinks } from "@/composables/useLinks"
import { useProviderStore } from "@/store/modules/provider/providerStore"
import { storeToRefs } from "pinia"
import { isCxApp } from "@/common/util/env"

const { useCases } = storeToRefs(useProviderStore())
const { fetchUsecases } = useProviderStore()

if (isCxApp()) {
  fetchUsecases()
}

const { t } = useI18n()

const { helpSection } = useLinks()
</script>
<style scoped lang="scss">
.card {
  height: 100%;
  &-header {
    margin-bottom: var(--scl-spacing-12);
  }
}

.connector-items {
  .connector-item {
    font: var(--telekom-text-style-body);
    gap: var(--scl-spacing-8);
    margin-bottom: var(--scl-spacing-8);
    white-space: no-wrap;

    .icon {
      &:hover {
        cursor: pointer;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }

    &--title {
      flex: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
